(()=>{
 'use strict';
 const root=window.Shopify?.routes?.root||'/';
 const nativeFetch=window.fetch.bind(window);
 const plans=new Map([[46810836009039,2097545295],[46810836074575,2097512527],[46800536895567,2093973583]]);
 const rules=[
  {parent:46810836009039,plan:2097545295,code:'NB-EYE-WELCOME-30-FIXED',gifts:[46811060404303,46810729742415]},
  {parent:46810836074575,plan:2097512527,code:'NB-EYE-WELCOME-90',gifts:[46810729742415,46810729775183,46810729807951]},
  {parent:46800536895567,plan:2093973583,code:'NB-SILK-WELCOME-90',gifts:[46800516218959,46800516677711,46800516710479]}
 ];
 let tail=Promise.resolve(),held=0,timer,checkingOut=false,externalWrites=0;
 async function begin(){
  const previous=tail;
  let unlock;
  tail=new Promise(resolve=>{unlock=resolve;});
  await previous; held++;
  let done=false;
  return ()=>{if(!done){done=true;held--;unlock();}};
 }
 async function request(path,body,retried=false){
  const controller=new AbortController();
  const timeout=setTimeout(()=>controller.abort(),15000);
  try{
   const r=await nativeFetch(root+path,{signal:controller.signal,method:body?'POST':'GET',headers:{Accept:'application/json','Content-Type':'application/json'},...(body?{body:JSON.stringify(body)}:{cache:'no-store'})});
   const data=await r.json();
   if(!r.ok)throw new Error(data.description||'Your cart could not be updated. Please try again.');
   return data;
  }catch(error){
   if(!body&&!retried&&error.name==='TypeError')return request(path,undefined,true);
   throw error;
  }finally{clearTimeout(timeout);}
 }
 const giftRule=item=>rules.find(rule=>rule.gifts.includes(item.variant_id)&& (item.properties?._eye_patches_gift&&String(rule.parent)===String(item.properties._eye_patches_parent)||item.properties?._nb_welcome_gift==='90-day'&&rule.parent===46800536895567));
 const qualifies=(cart,rule)=>cart.items.some(item=>item.variant_id===rule.parent&&item.selling_plan_allocation?.selling_plan?.id===rule.plan);
 function inspect(cart){
  const updates={},seen=new Set();
  for(const item of cart.items){
   const rule=giftRule(item);
   if(!rule)continue;
   const key=rule.parent+':'+item.variant_id;
   if(!qualifies(cart,rule)||seen.has(key))updates[item.key]=0;
   else {seen.add(key);if(item.quantity!==1)updates[item.key]=1;}
  }
  const pdrnParents=new Set([50520888803407,50520889458767,50520901484623]);
  const pdrnGroups=new Map();
  for(const item of cart.items){
   const marker=item.properties?._pdrn_offer;
   if(marker){if(!pdrnGroups.has(marker))pdrnGroups.set(marker,[]);pdrnGroups.get(marker).push(item);}
  }
  for(const group of pdrnGroups.values())if(!group.some(item=>pdrnParents.has(item.variant_id)))for(const item of group)updates[item.key]=0;
  return updates;
 }
 function verify(cart){
  for(const item of cart.items){
   if(plans.has(item.variant_id)&&item.selling_plan_allocation?.selling_plan?.id!==plans.get(item.variant_id))throw new Error('Please reselect your subscription before checking out. Its billing plan could not be confirmed.');
   if(giftRule(item)&&item.final_line_price!==0)throw new Error('Your welcome gifts are not showing as free. Please review your discount codes or contact us before checking out.');
   if(giftRule(item)&&item.selling_plan_allocation)throw new Error('A welcome gift has an unexpected subscription plan. Please remove it before checking out.');
  }
 }
 async function reconcile(strict=false){
  const release=await begin();
  try{
   let cart=await request('cart.js');
   let migrated=false;
   const legacy=cart.items.filter(item=>item.variant_id===46810729742415&&String(item.properties?._eye_patches_parent)==='46810836009039'&&item.properties?._eye_patches_gift);
   if(legacy.length){
    if(qualifies(cart,rules[0])&&!cart.items.some(item=>item.variant_id===46811060404303&&giftRule(item)===rules[0]))await request('cart/add.js',{items:[{id:46811060404303,quantity:1,properties:{_eye_patches_gift:'first-order',_eye_patches_parent:'46810836009039'}}]});
    cart=await request('cart/update.js',{updates:Object.fromEntries(legacy.map(item=>[item.key,0]))});migrated=true;
   }
   const updates=inspect(cart);
   const old=(cart.discount_codes||[]).map(x=>x.code);
   const codes=old.filter(code=>code.toUpperCase()!=='NB-EYE-WELCOME-30'&&!rules.some(rule=>rule.code===code.toUpperCase()));
   for(const rule of rules)if(qualifies(cart,rule)&&cart.items.some(item=>giftRule(item)===rule&&updates[item.key]!==0))codes.push(rule.code);
   const changed=Object.keys(updates).length>0||codes.map(x=>x.toUpperCase()).sort().join(',')!==old.map(x=>x.toUpperCase()).sort().join(',');
   if(changed)cart=await request('cart/update.js',{updates,discount:codes.join(',')});
   if(strict)verify(cart);
   return {cart,changed:changed||migrated};
  }finally{release();}
 }
 function notice(message){
  let el=document.getElementById('nb-cart-safety-message');
  if(!el){el=document.createElement('div');el.id='nb-cart-safety-message';el.setAttribute('role','alert');el.style.cssText='position:fixed;bottom:16px;left:16px;right:16px;z-index:2147483647;background:#fff;color:#722;padding:16px;border:1px solid #b77;box-shadow:0 3px 20px #0002';document.body.append(el);}
  el.textContent=message;
 }
 function schedule(){
  clearTimeout(timer);
  timer=setTimeout(async()=>{
   if(checkingOut||held||externalWrites)return;
   try{
    const result=await reconcile();
    if(result.changed){
     const drawer=document.querySelector('cart-drawer');
     if(drawer?.classList.contains('active')&&typeof drawer.renderContents==='function'){
      const ids=drawer.getSectionsToRender().map(section=>section.id);
      const sections=await request('?sections='+encodeURIComponent(ids.join(',')));
      if(ids.every(id=>sections[id]))drawer.renderContents({sections});
     }else if(location.pathname.replace(/\/$/,'')===root+'cart')location.reload();
    }
   }catch(error){notice('We could not verify your cart. Please check your connection before checkout.');}
  },600);
 }
 window.NativeBeautyCart={begin,reconcile,schedule};
 window.fetch=async function(input,options){
  let url;try{url=new URL(typeof input==='string'?input:input.url,location.href);}catch{return nativeFetch(input,options);}
  const write=url.origin===location.origin&&/\/cart\/(add|change|update|clear)(\.js)?$/.test(url.pathname);
  if(write)externalWrites++;
  try{return await nativeFetch(input,options);}finally{if(write){externalWrites--;schedule();}}
 };
 async function checkout(event){
  event.preventDefault();event.stopImmediatePropagation();
  if(checkingOut)return;
  checkingOut=true;clearTimeout(timer);
  document.getElementById('nb-cart-safety-message')?.remove();
  try{
   if(externalWrites)throw new Error('Your cart is still updating. Please try checkout again in a moment.');
   const result=await reconcile(true);
   if(!result.cart.item_count)throw new Error('Your cart is empty. Please add a product before checkout.');
   location.assign(root+'checkout');
  }catch(error){checkingOut=false;notice(error.name==='AbortError'?'Your connection timed out. Your cart is saved; please try checkout again.':['TypeError','SyntaxError'].includes(error.name)?'We could not verify your cart. Please check your connection and try checkout again.':error.message||'Please review your cart and try again.');}
 }
 document.addEventListener('click',event=>{
  const target=event.target instanceof Element?event.target.closest('[name="checkout"],a[href$="/checkout"]'):null;
  if(target)checkout(event);
 },true);
 document.addEventListener('submit',event=>{
  if(event.submitter?.name==='checkout')checkout(event);
 },true);
 function start(){
  document.querySelectorAll('cart-items,cart-drawer-items').forEach(el=>new MutationObserver(schedule).observe(el,{childList:true,subtree:true}));
  schedule();
 }
 document.readyState==='loading'?document.addEventListener('DOMContentLoaded',start):start();
 window.addEventListener('pageshow',()=>{checkingOut=false;schedule();});
})();
